<template lang="pug">
  header(:class="stickyHeaderClass")
    .sticky-mobile-bar
      button.hamburger.hamburger--3dy(
        type="button"
        :class="{ 'is-active': sidebar }"
        @click="toggleSidebar"
      )
        span.hamburger-box
          span.hamburger-inner
      ShoppingCart
  
    .header-menu-wrap
      .container.mx-auto.flex.justify-end
          Menu#header-menu(k="header-menu" :max-depth="3")
          ShoppingCart.text-white
    .container.mx-auto.header-bottom
      Menu#main-menu(k="main-menu" :max-depth="3")
      .logo
        component(:is="logoWrap" v-bind="logoWrapProps")
          img(v-if="logo && logo.id" :src="image.src" title="logo" rel="noopener")
    .header-area(v-if="sections && sections.length")
      section(
        v-for="(section, index) in sections"
        :key="section.id"
        :class="section.key"
        v-if="index === 0 && isAllowed(section.key)"
      )
        Banner(v-if="section.key === 'banner'" :section="section")
        Slider(v-if="section.key === 'slider'" :section="section")
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

import { trim } from "@/helpers";

import Menu from "@/components/Menu.vue";
import ShoppingCart from "@/extensions/shop/components/ShoppingCart.vue";

export default {
  name: "Header",
  data: () => ({
    lastScroll: 0,
    stickyHeaderClass: ""
  }),
  components: {
    Menu,
    ShoppingCart
  },
  computed: {
    logoWrap() {
      let tag = "div";
      if (this.$route.path !== "/") {
        tag = "a";
      }
      return tag;
    },
    logoWrapProps() {
      let props = {};
      if (this.$route.path !== "/") {
        props = { href: "/" };
      }
      return props;
    },
    image() {
      const storageRoute = trim(
        `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`,
        "/"
      );

      const fit = "fit&h=160";

      let width = this.logo.width;
      let height = this.logo.height;

      return {
        src: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}`,
        error: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}&preview=greyscale`,
        loading: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}&preview=blur`,
        width,
        height
      };
    },
    ...mapGetters({
      logo: "logo",
      menus: "menus",
      sidebar: "sidebar"
    })
  },
  methods: {
    openSearch() {
      console.log("open search bar");
    },
    toggleSidebar() {
      this.updateSidebarVisibility(!this.sidebar);
    },

    updateStickyHeader() {
      const currentScroll = window.pageYOffset;

      const scrollUp = "scroll-up";
      const scrollDown = "scroll-down";

      if (
        currentScroll > this.lastScroll &&
        this.stickyHeaderClass !== scrollDown
      ) {
        this.stickyHeaderClass = scrollDown;
      } else if (
        currentScroll < this.lastScroll &&
        this.stickyHeaderClass !== scrollUp
      ) {
        this.stickyHeaderClass = scrollUp;
      }

      this.lastScroll = currentScroll;
    },
    ...mapMutations({
      updateSidebarVisibility: "updateSidebarVisibility"
    })
  },
  mounted() {
    window.addEventListener("scroll", this.updateStickyHeader);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.updateStickyHeader);
  }
};
</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"

header
  @apply flex items-center justify-end flex-col bg-white
  .header-menu-wrap
    @apply w-full hidden
    @screen lg
      @apply block
      background-color: $etori-sec

    #header-menu
      @apply hidden
      @screen lg
        @apply flex items-center
      ::v-deep ul
        & > li
          @apply inline-block border-0
          &.active .tree-item a
            @apply text-gray-500
          .tree-item > a
            @apply font-medium transition duration-500 ease-in-out text-white px-3
            &:hover
              @apply text-gray-500

  .header-bottom
    @apply flex flex-col items-center mb-8
    .logo
        width: 130px
        font-size: 48px
    #main-menu
      @apply hidden
      @screen lg
        @apply block my-8
      &::v-deep
        ul
          &.tree-menu
            & > li
              transition: background-color .3s ease
              position: relative
              &.active > .tree-item > a:after,
              &.active.visible.hover > .tree-item > a:after
                transform: scaleX(1)

              &.visible.hover > .tree-item > a
                color: $cc-blue
                &:after
                  transform: scaleX(1)

              &.visible.hover.has-children
                > .tree-item a
                  color: $cc-blue

              &:last-of-type > .tree-item a
                margin-right: 0

              &:not(.full-width)
                position: relative
              & > .tree-item a
                @apply font-light text-base mx-3 uppercase
                color: $cc-blue
                transition: color .15s ease, border-color .3s ease
                &:after
                  @apply block absolute left-0 border-t-2 border-solid border-black
                  transition: transform .3s ease-out,border-color .3s ease-out
                  bottom: -6px
                  margin-left: 10px
                  width: calc(100% - 20px)
                  transform: scaleX(0)
                  content: ''
                & > .active
                  @apply text-white
              li
                width: 100%
                & > .tree-item a
                  @apply font-medium text-white block max-w-md p-2
                  background: $etori-sec
                  margin: 0
                  &:hover
                    background-color: $etori-base
                    color: #fff !important
                  &:after
                    transform: scaleX(0) !important
                &.hover
                  & > .tree-item a
                    color: #fff
        & > ul
          &.tree-menu
            & > li
              display: inline-block
              & > ul
                &.tree-menu
                  @apply absolute z-50 inline-block max-w-md left-0 shadow-sm
                  top: 40px
                  min-width: 200px
                  z-index: 100
            ul ul
              @apply absolute top-0
              left: 100%
              min-width: 200px
              margin-bottom: 9px

        .show-enter-active, .show-leave-active
          transition: opacity 0.3s ease, transform 0.3s ease
          transform-origin: left center
        .show-enter, .show-leave-to
          opacity: 0
          transform: translateY(6px)

  .sticky-mobile-bar
    @apply absolute
    top: 18px
    left: 0
    backdrop-filter: blur(20px)
    transition: transform .15s linear
    z-index: 10
    color: $cc-blue
    @screen md
      left: 98px
    @screen lg
      @apply hidden
    &.scroll-down
      transform: translateY(-54px)
    .hamburger
      height: 53px
      padding: 15px
      .hamburger-inner
        background-color: $cc-blue
        &:before, &:after
          background-color: $cc-blue
    .shopping-cart
      padding: 0 1rem
</style>
